const CROPPER_CONFIG = {
    viewMode: 1,
    zoomTo: 0.5,
    dragMode: 'move',
    background: false,
    checkOrientation: false,
    style: { height: 400, width: '100%' },
    minCropBoxHeight: 50,
    minCropBoxWidth: 50,
    center: true,
    responsive: true,
    guides: true,
    zoomable: true,
    mouseWheelZoom: true
};

export default CROPPER_CONFIG;
